import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MaestroMarcas } from 'src/app/models/generic/MaestroMarcas';
import { MaestroMarcasReferencias } from 'src/app/models/generic/MaestroMarcasReferencias';
import { MaestroMarcasActualizacion } from 'src/app/models/generic/MaestroMarcasActualizacion';
import { Maestros_MarcasService } from 'src/app/services/maestros_marcas.service';

@Component({
  selector: 'maestros-marcas-editar',
  templateUrl: './maestros-marcas-editar.component.html',
  styleUrls: ['./maestros-marcas-editar.component.scss']
})
export class MaestrosMarcasEditarComponent implements OnInit{
  
  form: FormGroup;
  formConsulta: FormGroup;
  tituloForma: string = 'Marcas';
  tituloBoton: string = 'Guardar';
  mostrarCargando: boolean = false;
  codigoAccion: string = '';
  codigoAccionActualizacion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  detalleSeleccionadoReferencias: number;
  formReferencias: FormGroup;
  editarRegistroReferencias: boolean = false;
  @ViewChild('paginatorreferencias') paginatorreferencias: MatPaginator;
  @ViewChild(MatSort) sortreferencias: MatSort;
  dataSourceReferencias: MatTableDataSource<MaestroMarcasReferencias>;
  columnasEncabezadoReferencias: string[] = ['id', 'codigo', 'descripcion', 'acciones'];
  listaDatosReferencias: MaestroMarcasReferencias[] = [];
  listaDatosReferenciasFiltrada: MaestroMarcasReferencias[] = [];
  listaDatosReferenciasGuardar: MaestroMarcasReferencias[] = [];
  listaDatosReferenciasEliminar: MaestroMarcasReferencias[] = [];
  parametrosPrincipal: MaestroMarcas;
  tabItemSeleccionado: string = 'tabInformacion';
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_MarcasService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public modal: MatDialog) {}

  ngOnInit() {
    this.IniciarFormulario();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorreferencias);

    console.log('parametros', this.menuService.ParametrosAdicionales);
    if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);
      if (this.utilitariosService.VerificarContieneDatos(this.parametrosPrincipal)) {
        this.form.setValue(this.parametrosPrincipal);
      }
    }

    if (!this.utilitariosService.VerificarContieneDatos(this.parametrosPrincipal)) {
      this.parametrosPrincipal = new MaestroMarcas();
    }
    
    this.tituloForma = 'Edición de marcas';
    this.tituloBoton = 'Guardar';

    this.ConsultarRegistrosReferencias();
  }
  tabSeleccionado(item: any) {
    console.log('tabSeleccionado', item);
    this.tabItemSeleccionado = item.tab.textLabel;
  }
  IniciarFormulario() {
    this.form = this.fb.group({
      'id': new FormControl(0),
      'codigo': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(100)]),
    });

    this.formConsulta = this.fb.group({
      filtro: ['']
    });

    this.IniciarFormularioReferencias();
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosMarcasComponent');
  }
  Guardar(codigoAccionActualizacion: string = '') {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this.codigoAccionActualizacion = codigoAccionActualizacion;
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      if (codigoAccionActualizacion !== '') {
        this.utilitariosService.MensajeToast('Es necesario que la pestaña de información tenga los datos validos para utilizar esta opción.');
      }
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      } else if (this.codigoAccion === 'eliminarReferencias') {
        this.EliminarRegistroReferencia();
      }
    }
  }
  ActualizarRegistro() {
    if (!this.mostrarCargando) {
      this.mostrarCargando = true;
    
      let parametrosActualizacion: MaestroMarcasActualizacion = new MaestroMarcasActualizacion();
      parametrosActualizacion.principal = new MaestroMarcas();
      parametrosActualizacion.principal.id = this.form.get('id').value;
      parametrosActualizacion.principal.codigo = this.form.get('codigo').value;
      parametrosActualizacion.principal.descripcion = this.form.get('descripcion').value;
      
      parametrosActualizacion.listaMarcasReferencias = this.listaDatosReferenciasGuardar;
      parametrosActualizacion.listaMarcasReferenciasEliminar = this.listaDatosReferenciasEliminar;
  
      this.datosServices.Actualizar(parametrosActualizacion)
              .subscribe((resp: RespuestaGenerica) =>{
                this.mostrarCargando = false;
                if (!resp.procesoExitoso) {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                } else {
                  this.form.get('id')?.setValue(resp.id);
                  this.menuService.CambiarComponenteActivo('MaestrosMarcasComponent');
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosReferencias() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        filtro: ['']
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      
      this.datosServices.ConsultarReferencias(parametrosConsulta.value)
                .subscribe((resp: MaestroMarcasReferencias[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosReferencias = resp;
                  this.FiltrarRegistrosReferencias();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  //referencias
  IniciarFormularioReferencias() {
    this.formReferencias = this.fb.group({
      'id': new FormControl(0),
      'codigo': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(100)]),
    });
  }
  recargarListaReferencias() {
    this.dataSourceReferencias = new MatTableDataSource(this.listaDatosReferenciasFiltrada);
    setTimeout(() => {
      this.dataSourceReferencias.paginator = this.paginatorreferencias;
      this.dataSourceReferencias.sort = this.sortreferencias;
    });
  }
  NuevoReferencia() {
    this.editarRegistroReferencias = true;
    this.IniciarFormularioReferencias();
    this.formReferencias.get('id').setValue((this.listaDatosReferencias.length + 1) * -1);
  }
  EditarReferencia(referenciaEditar: MaestroMarcasReferencias) {
    this.editarRegistroReferencias = true;
    this.formReferencias.setValue(referenciaEditar);
  }
  EliminarReferencia(plazosEditar: MaestroMarcasReferencias) {
    this.detalleSeleccionadoReferencias = plazosEditar.id;
    this.codigoAccion = 'eliminarReferencias';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarReferencia() {
    if (this.formReferencias.valid) {
      // validar si existe el registro
      if (this.listaDatosReferencias.filter(x => x.id !== this.formReferencias.get('id').value
                                            && (x.codigo === this.formReferencias.get('codigo').value
                                              || x.descripcion === this.formReferencias.get('descripcion').value)).length > 0) {
        this.utilitariosService.MensajeToast('Ya existe un registro con el mismo Código o Descripción');
        return;
      }
      
      this.editarRegistroReferencias = false;
      
      if (this.listaDatosReferencias.filter(x => x.id === this.formReferencias.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosReferencias.filter(x => x.id === this.formReferencias.get('id').value)[0];
        parametroActualizar.codigo = this.formReferencias.get('codigo').value;
        parametroActualizar.descripcion = this.formReferencias.get('descripcion').value;
      } else {
        this.listaDatosReferencias.push(this.formReferencias.value);
      }

      if (this.listaDatosReferenciasGuardar.filter(x => x.id === this.formReferencias.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosReferenciasGuardar.filter(x => x.id === this.formReferencias.get('id').value)[0];
        parametroActualizar.codigo = this.formReferencias.get('codigo').value;
        parametroActualizar.descripcion = this.formReferencias.get('descripcion').value;
      } else {
        this.listaDatosReferenciasGuardar.push(this.formReferencias.value);
      }
      
      this.FiltrarRegistrosReferencias();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formReferencias);
    }
  }
  CancelarEditarReferencia() {
    this.editarRegistroReferencias = false;
  }
  EliminarRegistroReferencia() {
    if (this.detalleSeleccionadoReferencias > 0) {
      this.listaDatosReferenciasEliminar.push(this.listaDatosReferencias.filter(x => x.id === this.detalleSeleccionadoReferencias)[0]);
    }
    let listaNueva: MaestroMarcasReferencias[] = [];
    for (let index = 0; index < this.listaDatosReferencias.length; index++) {
      if (this.listaDatosReferencias[index].id !== this.detalleSeleccionadoReferencias) {
        listaNueva.push(this.listaDatosReferencias[index]);
      }
    }
    this.listaDatosReferencias = listaNueva;
    this.FiltrarRegistrosReferencias();
  }
  FiltrarRegistrosReferencias() {
    let filtrarTexto: string = this.formConsulta.get('filtro').value.toString();
    filtrarTexto = filtrarTexto.toLowerCase();
    this.listaDatosReferenciasFiltrada = this.listaDatosReferencias.filter(x => 
      x.id.toString().includes(filtrarTexto)
      || x.codigo.toLowerCase().includes(filtrarTexto) 
      || x.descripcion.toLowerCase().includes(filtrarTexto));
    this.recargarListaReferencias();
  }
  //**************************************/
}
